<template>
  <v-card flat>
    <v-card-title>
      <span>Você irá enviar a mensagem para {{ }} usuários</span>
    </v-card-title>

    <v-card-text>
      <form-group class="ma-0 pa-0">
        <v-row
          justify="start"
          align="center"
        >
          <v-checkbox
            id="reviewSendSms"
            v-model="payload.sendSms"
            label="SMS"
          />
          <v-btn
            color="primary"
            outlined
            class="ml-4"
            @click="viewTab(2)"
          >
            Editar/visualizar
          </v-btn>
        </v-row>
        <v-row
          justify="start"
          align="center"
        >
          <v-checkbox
            id="reviewSendPush"
            v-model="payload.sendPush"
            label="PUSH"
          />
          <v-btn
            color="primary"
            outlined
            class="ml-4"
            @click="viewTab(0)"
          >
            Editar/visualizar
          </v-btn>
        </v-row>
        <v-row
          justify="start"
          align="center"
        >
          <v-checkbox
            id="reviewSendEmail"
            v-model="payload.sendEmail"
            label="E-mail"
          />
          <v-btn
            color="primary"
            class="ml-4"
            outlined
            @click="viewTab(1)"
          >
            Editar/visualizar
          </v-btn>
        </v-row>
      </form-group>
    </v-card-text>
    <slot />
  </v-card>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';

export default {
  name: 'NotificationReviewContent',
  components: { FormGroup },
  computed: {
    payload() {
      return this.notification.payload;
    },
    stepper() {
      return this.notification.stepper;
    },
  },
  methods: {
    viewTab(tab) {
      this.$emit('to-message-tab', tab);
    },
  },
  inject: {
    notification: {
      default() {
        return {
          payload: {
            sendPush: '',
            sendEmail: '',
            sendSms: '',
          },
          stepper: '',
        };
      },
    },
  },
};
</script>
